import {PennylaneDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_UNMATCHED_TRANSACTIONS';

export async function getUnmatchedTransactions(userData: Record<string, string>) {
    try {
        const result = await PennylaneDao.getUnmatchedTransactions(userData);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
